module.exports = __webpack_public_path__ + "media/components/assistant/images/icons/rocket-f94736dd72054a0a29d9289245f9f579.svg";